import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useEffect, useState} from 'react'
import {useGetActivityList} from 'src/feature/transaction-list/context/useQuery'
import {useActivityList} from 'src/feature/transaction-list/hook/activityList'
import FilterDrawer from 'src/feature/transaction-list/component/ActivityList/FilterDrawer'

const ProviderActivities = () => {
  const intl = useIntl()

  const {isLoading} = useGetActivityList()
  const {listFilter, listFilterSet, list} = useActivityList()
  const [open, setOpen] = useState(false)

  const paging = list?.paging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 1,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'id',
      dataIndex: 'id',
      title: 'ID',
    },
    {
      key: 'member',
      dataIndex: 'member',
      title: 'Member Name',
      render: (text: any) => (
        <>
          {text?.name && text?.surname ? (
            <span>{`${text?.name} ${text?.surname}`}</span>
          ) : (
            <span>-</span>
          )}
        </>
      ),
    },
    {
      key: 'createdOn',
      dataIndex: 'createdOn',
      title: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS.DATE_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'packageName',
      dataIndex: 'packageName',
      title: 'Membership Name',
    },
    {
      key: 'packageItem',
      dataIndex: 'packageItem',
      title: 'Membership Product',
    },
    {
      key: 'storeName',
      dataIndex: 'storeName',
      title: 'Store Name',
    },
    {
      key: 'credit',
      dataIndex: 'credit',
      title: 'Credit Used',
    },
  ]

  useEffect(() => {
    if (listFilter.filterList.length > 0 || listFilter.paging.currentPageNumber > 1) {
      listFilterSet({
        ...listFilter,
        filterList: [],
        paging: {
          ...paging,
          currentPageNumber: 1,
        },
      })
    }
  }, [])

  return (
    <>
      <FilterDrawer setOpen={setOpen} open={open} />

      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>{intl.formatMessage({id: 'MENU.ACTIVITIES'})}</h3>
              <p className='text-muted fw-normal fs-6'>
                View a detailed log of all service usage across your member base, including
                membership and location information.
              </p>
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  className='btn btn-light'
                  onClick={() => setOpen(true)}
                  // id='kt_filter_membertrx_button'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={isLoading}
              dataSource={list?.dataList}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!list || !list.dataList) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== list.paging.pageSize ? 1 : current

                  listFilterSet({
                    ...listFilter,
                    paging: {
                      ...paging,
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ProviderActivities
